/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ShopifyOriginConfig
 */
export interface ShopifyOriginConfig {
  /**
   *
   * @type {string}
   * @memberof ShopifyOriginConfig
   */
  businessName?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyOriginConfig
   */
  addressLine?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyOriginConfig
   */
  addressLine2?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyOriginConfig
   */
  city?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyOriginConfig
   */
  stateOrProvinceCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyOriginConfig
   */
  postalCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyOriginConfig
   */
  countryCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyOriginConfig
   */
  contactName?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyOriginConfig
   */
  contactPhone?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyOriginConfig
   */
  contactEmail?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyOriginConfig
   */
  openFromLocalTime?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyOriginConfig
   */
  openToLocalTime?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof ShopifyOriginConfig
   */
  hasDock?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof ShopifyOriginConfig
   */
  hasForklift?: boolean | null;
}

/**
 * Check if a given object implements the ShopifyOriginConfig interface.
 */
export function instanceOfShopifyOriginConfig(
  value: object,
): value is ShopifyOriginConfig {
  return true;
}

export function ShopifyOriginConfigFromJSON(json: any): ShopifyOriginConfig {
  return ShopifyOriginConfigFromJSONTyped(json, false);
}

export function ShopifyOriginConfigFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShopifyOriginConfig {
  if (json == null) {
    return json;
  }
  return {
    businessName:
      json["businessName"] == null ? undefined : json["businessName"],
    addressLine: json["addressLine"] == null ? undefined : json["addressLine"],
    addressLine2:
      json["addressLine2"] == null ? undefined : json["addressLine2"],
    city: json["city"] == null ? undefined : json["city"],
    stateOrProvinceCode:
      json["stateOrProvinceCode"] == null
        ? undefined
        : json["stateOrProvinceCode"],
    postalCode: json["postalCode"] == null ? undefined : json["postalCode"],
    countryCode: json["countryCode"] == null ? undefined : json["countryCode"],
    contactName: json["contactName"] == null ? undefined : json["contactName"],
    contactPhone:
      json["contactPhone"] == null ? undefined : json["contactPhone"],
    contactEmail:
      json["contactEmail"] == null ? undefined : json["contactEmail"],
    openFromLocalTime:
      json["openFromLocalTime"] == null ? undefined : json["openFromLocalTime"],
    openToLocalTime:
      json["openToLocalTime"] == null ? undefined : json["openToLocalTime"],
    hasDock: json["hasDock"] == null ? undefined : json["hasDock"],
    hasForklift: json["hasForklift"] == null ? undefined : json["hasForklift"],
  };
}

export function ShopifyOriginConfigToJSON(json: any): ShopifyOriginConfig {
  return ShopifyOriginConfigToJSONTyped(json, false);
}

export function ShopifyOriginConfigToJSONTyped(
  value?: ShopifyOriginConfig | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    businessName: value["businessName"],
    addressLine: value["addressLine"],
    addressLine2: value["addressLine2"],
    city: value["city"],
    stateOrProvinceCode: value["stateOrProvinceCode"],
    postalCode: value["postalCode"],
    countryCode: value["countryCode"],
    contactName: value["contactName"],
    contactPhone: value["contactPhone"],
    contactEmail: value["contactEmail"],
    openFromLocalTime: value["openFromLocalTime"],
    openToLocalTime: value["openToLocalTime"],
    hasDock: value["hasDock"],
    hasForklift: value["hasForklift"],
  };
}
